/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.base$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.base$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.base$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true
    }
  },
  {
    name: 'about',
    path: '/about',
    component: 'layout.base$view.about',
    meta: {
      title: 'about',
      i18nKey: 'route.about'
    }
  },
  {
    name: 'contact',
    path: '/contact',
    component: 'layout.base$view.contact',
    meta: {
      title: 'contact',
      i18nKey: 'route.contact'
    }
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home'
    }
  },
  {
    name: 'industry-trends',
    path: '/industry-trends',
    component: 'layout.base$view.industry-trends',
    meta: {
      title: 'industry-trends',
      i18nKey: 'route.industry-trends'
    }
  },
  {
    name: 'legal',
    path: '/legal',
    component: 'layout.base$view.legal',
    meta: {
      title: 'legal',
      i18nKey: 'route.legal'
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.base$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true
    }
  },
  {
    name: 'membership-advantage',
    path: '/membership-advantage',
    component: 'layout.base',
    meta: {
      title: 'membership-advantage',
      i18nKey: 'route.membership-advantage'
    },
    children: [
      {
        name: 'membership-advantage_advanced-tech-system',
        path: '/membership-advantage/advanced-tech-system',
        component: 'view.membership-advantage_advanced-tech-system',
        meta: {
          title: 'membership-advantage_advanced-tech-system',
          i18nKey: 'route.membership-advantage_advanced-tech-system'
        }
      },
      {
        name: 'membership-advantage_community-support',
        path: '/membership-advantage/community-support',
        component: 'view.membership-advantage_community-support',
        meta: {
          title: 'membership-advantage_community-support',
          i18nKey: 'route.membership-advantage_community-support'
        }
      },
      {
        name: 'membership-advantage_cost-reduction',
        path: '/membership-advantage/cost-reduction',
        component: 'view.membership-advantage_cost-reduction',
        meta: {
          title: 'membership-advantage_cost-reduction',
          i18nKey: 'route.membership-advantage_cost-reduction'
        }
      },
      {
        name: 'membership-advantage_financial-tax-consulting',
        path: '/membership-advantage/financial-tax-consulting',
        component: 'view.membership-advantage_financial-tax-consulting',
        meta: {
          title: 'membership-advantage_financial-tax-consulting',
          i18nKey: 'route.membership-advantage_financial-tax-consulting'
        }
      },
      {
        name: 'membership-advantage_increase-turnover',
        path: '/membership-advantage/increase-turnover',
        component: 'view.membership-advantage_increase-turnover',
        meta: {
          title: 'membership-advantage_increase-turnover',
          i18nKey: 'route.membership-advantage_increase-turnover'
        }
      },
      {
        name: 'membership-advantage_marketing-promotion',
        path: '/membership-advantage/marketing-promotion',
        component: 'view.membership-advantage_marketing-promotion',
        meta: {
          title: 'membership-advantage_marketing-promotion',
          i18nKey: 'route.membership-advantage_marketing-promotion'
        }
      },
      {
        name: 'membership-advantage_membership-program',
        path: '/membership-advantage/membership-program',
        component: 'view.membership-advantage_membership-program',
        meta: {
          title: 'membership-advantage_membership-program',
          i18nKey: 'route.membership-advantage_membership-program'
        }
      },
      {
        name: 'membership-advantage_procurement-cost-optimization',
        path: '/membership-advantage/procurement-cost-optimization',
        component: 'view.membership-advantage_procurement-cost-optimization',
        meta: {
          title: 'membership-advantage_procurement-cost-optimization',
          i18nKey: 'route.membership-advantage_procurement-cost-optimization'
        }
      },
      {
        name: 'membership-advantage_smart-ordering-platform',
        path: '/membership-advantage/smart-ordering-platform',
        component: 'view.membership-advantage_smart-ordering-platform',
        meta: {
          title: 'membership-advantage_smart-ordering-platform',
          i18nKey: 'route.membership-advantage_smart-ordering-platform'
        }
      },
      {
        name: 'membership-advantage_sustainability',
        path: '/membership-advantage/sustainability',
        component: 'view.membership-advantage_sustainability',
        meta: {
          title: 'membership-advantage_sustainability',
          i18nKey: 'route.membership-advantage_sustainability'
        }
      }
    ]
  },
  {
    name: 'question',
    path: '/question',
    component: 'layout.base$view.question',
    meta: {
      title: 'question',
      i18nKey: 'route.question'
    }
  },
  {
    name: 'service',
    path: '/service',
    component: 'layout.base$view.service',
    meta: {
      title: 'service',
      i18nKey: 'route.service'
    }
  },
  {
    name: 'supplier',
    path: '/supplier',
    component: 'layout.base$view.supplier',
    meta: {
      title: 'supplier',
      i18nKey: 'route.supplier'
    }
  }
];
